import React, { RefObject } from 'react';

interface HeaderProps {
  onRefresh: () => void;
  onSettingsClick: () => void;
  onDonateClick: () => void;
  onSuggestionsClick: () => void;
  searchQuery: string;
  onSearchChange: (query: string) => void;
  searchInputRef?: RefObject<HTMLInputElement>;
}

export default function Header({ onRefresh, onSettingsClick, onDonateClick, onSuggestionsClick, searchQuery, onSearchChange, searchInputRef }: HeaderProps) {
  return (
    <header className="bg-gradient-to-br from-bg-secondary via-bg-secondary to-bg-tertiary rounded-3xl p-8 mb-8 shadow-bubble-lg border-2 border-primary/10">
      <h1 className="text-5xl mb-6 bg-gradient-to-r from-primary via-purple-500 to-pink-500 bg-clip-text text-transparent font-extrabold tracking-tight">
        🔭 CryptoScope
      </h1>
      <div className="flex flex-wrap gap-4 items-center">
        <div className="flex-1 min-w-[250px] relative">
          <input
            ref={searchInputRef}
            type="text"
            placeholder="🔍 Search cryptocurrencies... (Press /)"
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            className="w-full px-6 py-4 bg-bg border-2 border-border rounded-full text-text text-base transition-all duration-300 focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary/20 focus:shadow-bubble placeholder:text-text-secondary/50"
          />
        </div>
        <button
          onClick={onRefresh}
          className="px-8 py-4 bg-gradient-to-r from-primary to-primary-light border-none rounded-full text-white text-base font-semibold cursor-pointer transition-all duration-300 hover:scale-110 hover:shadow-bubble-lg hover:shadow-primary/50 active:scale-95"
        >
          🔄 Refresh
        </button>
        <button
          onClick={onDonateClick}
          className="px-8 py-4 bg-gradient-to-r from-pink-500 to-purple-500 border-none rounded-full text-white text-base font-semibold cursor-pointer transition-all duration-300 hover:scale-110 hover:shadow-bubble-lg hover:shadow-pink-500/50 active:scale-95"
          title="Support CryptoScope"
        >
          💝 Donate
        </button>
        <button
          onClick={onSuggestionsClick}
          className="px-8 py-4 bg-gradient-to-r from-blue-500 to-cyan-500 border-none rounded-full text-white text-base font-semibold cursor-pointer transition-all duration-300 hover:scale-110 hover:shadow-bubble-lg hover:shadow-blue-500/50 active:scale-95"
          title="Suggestions & Bug Reports"
        >
          💬 Feedback
        </button>
        <button
          onClick={onSettingsClick}
          className="px-6 py-4 bg-bg-tertiary border-2 border-border rounded-full text-text text-2xl cursor-pointer transition-all duration-300 min-w-[60px] hover:bg-gradient-to-br hover:from-primary hover:to-primary-light hover:border-primary hover:text-white hover:scale-110 hover:rotate-90 hover:shadow-bubble-lg active:scale-95"
          title="Settings"
        >
          ⚙️
        </button>
      </div>
    </header>
  );
}

